import React from "react";
import { API } from "../config/config";
import axios from "axios";
import Button from "components/CustomButtons/Button.jsx";
import Grid from "@material-ui/core/Grid";
import { Spiner } from "../Spinner/Spinner";
import PersianCalender from "../datepicker";
import BootMulti from "./bootMulti";
import { Collapse, Button as BootButton } from "react-bootstrap";

export default class AllPosts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subcategories: [],
      status: "",
      category: "",
      loading: false,
      defaultdate: null,
      selectStatus: [
        { label: "ثابت", value: 1 },
        { label: "کاهش", value: 2 },
        { label: "افزایش", value: 3 }
      ],
      expand: false
    };
  }

  async componentDidMount() {
    try {
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: false,
        credentials: "same-origin",
        url: API + "/api/Imcat2s/GetImcat2s"
      };
      let response = await axios(options);
      if (response.status === 200) {
        const subcategories = [];
        response.data.results.map(sub =>
          subcategories.push({
            value: sub.id,
            label: sub.imcat1.name + " " + sub.name
          })
        );

        await this.setState({ subcategories });
      }
    } catch (err) {
      await this.setState({
        message_error:
          "متاسفانه مشکلی در دریافت اطلاعات بوجود آمده لطفا دوباره سعی نمایید."
      });
    }
  }

  async FromDate(e) {
    await this.setState({ defaultdate: e });
  }
  async getcategory(e) {
    await this.setState({ category: e });
  }
  async getstatus(e) {
    await this.setState({ status: e });
  }
  handleExpand() {
    this.setState({ expand: !this.state.expand });
  }
  async search() {
    this.setState({ loading: true, expand: false });
    const { defaultdate, status, category } = this.state;
    const formData = new FormData();
    if (defaultdate) {
      formData.append("date", defaultdate);
    }
    if (category !== "") {
      formData.append("imcat2_id", category);
    }
    if (status !== "") {
      formData.append("price_change_id", status);
    }
    try {
      let responseinfo = await axios.post(API + "/api/Ims/GetIms", formData);
      if (responseinfo.status === 200) {
        this.props.get(responseinfo.data.results);
        this.setState({ loading: false });
      } else {
        console.log(responseinfo);
        this.props.get([]);
      }
    } catch (err) {
      this.props.get([]);
    }
  }

  render() {
    const { subcategories, loading, selectStatus, expand } = this.state;
    return (
      <div className="search-post">
        {loading && <Spiner />}
        <div className="cloapsediv">
          <BootButton
            onClick={() => this.setState({ expand: !expand })}
            aria-controls="example-collapse-text"
            aria-expanded={expand}
            className="cloapsbut"
          >
            سبا
          </BootButton>
          <div
            className="colapscontent"
            onClick={() => this.setState({ expand: !expand })}
            style={{ cursor: "pointer" }}
          >
            <span>جستجو...</span>
          </div>
          <Collapse in={expand}>
            <div id="example-collapse-text" className="colapsemaindiv">
              <Grid container className={"search-main-grid"} spacing={2}>
                <Grid item xs={12} md={6} className="ex-detail-grid">
                  <BootMulti
                    menus={subcategories}
                    getData={this.getcategory.bind(this)}
                    label="مجموعه"
                    isMulti={false}
                  />
                </Grid>
                <Grid item xs={12} md={6} className="ex-detail-grid">
                  <BootMulti
                    menus={selectStatus}
                    getData={this.getstatus.bind(this)}
                    label="وضعیت"
                    isMulti={false}
                  />
                </Grid>
                <Grid item xs={12} md={6} className="ex-detail-grid">
                  <PersianCalender getDate={this.FromDate.bind(this)} />
                </Grid>
              </Grid>
              <Grid item xs={12} md={12} className="ex-detail-grid">
                <Button className="search-but" onClick={this.search.bind(this)}>
                  جستجو
                </Button>
                <Button
                  className="search-but"
                  onClick={() => window.location.replace("/market")}
                >
                  حذف جستجو
                </Button>
              </Grid>
            </div>
          </Collapse>
        </div>
      </div>
    );
  }
}
